import { createReducer } from '@reduxjs/toolkit';
import DebugActions from './DebugActions';
import { DebugState } from './DebugState';

const initialState: DebugState = {
  debugMode: false,
  isImageProcessingPaused: false,
  moonImages: {
    single: {
      croppedTitles: [],
      croppedFilteredTitles: [],
      croppedNames: [],
      croppedFilteredNames: []
    },
    multi: {
      croppedNames: [],
      croppedFilteredNames: []
    }
  }
};
export const debugReducer = createReducer<DebugState>(initialState, (builder) => {
  builder.addCase(DebugActions.setDebugMode, (state, action) => ({ ...state, debugMode: action.payload }));
  builder.addCase(DebugActions.setIsImageProcessingPaused, (state, action) => ({
    ...state,
    isImageProcessingPaused: action.payload
  }));
  builder.addCase(DebugActions.addSingleMoonCroppedTitle, (state, action) => ({
    ...state,
    moonImages: {
      ...state.moonImages,
      single: {
        ...state.moonImages.single,
        croppedTitles: [action.payload, ...state.moonImages.single.croppedTitles].slice(0, 15)
      }
    }
  }));
  builder.addCase(DebugActions.addSingleMoonCroppedFilteredTitle, (state, action) => ({
    ...state,
    moonImages: {
      ...state.moonImages,
      single: {
        ...state.moonImages.single,
        croppedFilteredTitles: [action.payload, ...state.moonImages.single.croppedFilteredTitles].slice(0, 15)
      }
    }
  }));
  builder.addCase(DebugActions.addSingleMoonCroppedName, (state, action) => ({
    ...state,
    moonImages: {
      ...state.moonImages,
      single: {
        ...state.moonImages.single,
        croppedNames: [action.payload, ...state.moonImages.single.croppedNames].slice(0, 15)
      }
    }
  }));
  builder.addCase(DebugActions.addSingleMoonCroppedFilteredName, (state, action) => ({
    ...state,
    moonImages: {
      ...state.moonImages,
      single: {
        ...state.moonImages.single,
        croppedFilteredNames: [action.payload, ...state.moonImages.single.croppedFilteredNames].slice(0, 15)
      }
    }
  }));
  builder.addCase(DebugActions.addMultiMoonCroppedName, (state, action) => ({
    ...state,
    moonImages: {
      ...state.moonImages,
      multi: {
        ...state.moonImages.multi,
        croppedNames: [action.payload, ...state.moonImages.multi.croppedNames].slice(0, 15)
      }
    }
  }));
  builder.addCase(DebugActions.addMultiMoonCroppedFilteredName, (state, action) => ({
    ...state,
    moonImages: {
      ...state.moonImages,
      multi: {
        ...state.moonImages.multi,
        croppedFilteredNames: [action.payload, ...state.moonImages.multi.croppedFilteredNames].slice(0, 15)
      }
    }
  }));
});
